<template>
  <tooltip
    :text="tooltipContent"
    placement="top">
    <div
      class="beta-tag-wrapper"
      :aria-label="tooltipContent"
      tabindex="0">
      <div class="beta-tag" :class="sizeClass">
        <span class="beta-text">
          Beta
        </span>
      </div>
    </div>
  </tooltip>
</template>

<script>
export default {
  name: 'BetaBadge',
  props: {
    size: {
      type: String,
      default: 'normal',
      validator: (value) => ['small', 'normal'].includes(value)
    }
  },
  computed: {
    sizeClass() {
      return this.size === 'small' ? 'beta-tag-small' : ''
    }
  },
  data() {
    return {
      tooltipContent: 'This new feature is in active development. Your feedback will help us improve it.'
    }
  }
}
</script>

<style scoped lang="less">
@import "~@/variables.less";

.beta-tag-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.beta-tag {
  background: white;
  color: @blueDark;
  padding: 0.125rem 0.8rem;
  border-radius: 9999px;
  font-weight: 400;
  font-size: 1rem;
  display: inline-block;
  border: 1px solid @blueDark;
}

.beta-text {
  line-height: 1;
}

.beta-tag-small {
  padding: 0.0625rem 0.5rem;
  font-size: 0.75rem;
}
</style>
